import React, {
  useEffect,
  useRef,
} from 'react';
import { createPortal } from 'react-dom';

import useBreakpoints from 'utils/useBreakpoints';

import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import {
  Button,
  IconButton,
} from '@mui/material';

import BackgroundVideo from '../Media/BackgroundVideo';
import styles from './Modal.module.css';

const Modal = ({ onClose,children,width="50%", height="70%" ,closeIcon=true,sx={}
,sxBackground={},blurBackground=false,backgroundVideo=false,closeIconPosition="outside"}) => {
  const { isMobile } = useBreakpoints();
  const modalBackgroundRef = useRef(null);

  // Function to handle clicks outside the modal
  const handleOutsideClick = (e) => {
    if (modalBackgroundRef.current === e.target) {
      onClose();
    }
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);

    // Clean up the event listener when the component is unmounted
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [onClose]);

  useEffect(() => {
    const appContent = document.getElementById('appLayout');
    const modalContainer = document.createElement('div');
    appContent.parentNode.insertBefore(modalContainer, appContent.nextSibling);

    return () => {
      modalContainer.remove();
    };
  }, []);

  const modalWidth = isMobile ? '100%' : width;
  const modalHeight = isMobile ? '100%' : height;
  const modalPosition = isMobile ? 'fixed' : 'relative';
  const modalBorderRadius = isMobile ? '0' : '8px';

  return (
    <>
    {createPortal (
    <div
    id="modal"
    ref={modalBackgroundRef}
      className={styles["modalBackground"]}
      style={{...sxBackground,backdropFilter:blurBackground && "blur(10px)"}}
      onClick={handleOutsideClick}>
      {backgroundVideo && <div style={{position:"absolute",width:"100%",height:"100%"}}>
      <BackgroundVideo/>
      </div>}
      <div className={styles["modalContainer"]} style={{
        width: modalWidth,
        height: modalHeight,
        position: modalPosition,
        borderRadius: modalBorderRadius,
        boxSizing:"border-box",
        ...sx
      }}>
      
      {(closeIcon && closeIconPosition==="outside" && !isMobile) && 
        <Button style={{background:"black",position:"absolute",top:5,right:"-40px",padding:"0",margin:"0",minWidth:"0"}}>
          <CloseSharpIcon onClick={onClose} style={{color:"white"}}/>
        </Button>
      }
      
      {(closeIcon && (closeIconPosition !== "outside" || isMobile)) && 
      <IconButton style={{
        position:"absolute",
        top: "30px",
        right: "30px",
        padding:"0",
        margin:"0",
        minWidth:"0",
        backgroundColor: "#fafafa"
      }}>
        <CloseSharpIcon onClick={onClose}/>
      </IconButton>}
      
      <div style={{width:"100%",height:"100%",overflow:"auto"}}>
        {children}
      </div>
      </div>
    </div>, document.body)}
    </>
  );
};

export default Modal;